import React from "react";
import Card from "../../../components/ACS-Dashboard/ACS-Blocks/Card";
import ScrollableContainer from "../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer";

const ManageTeamList = () => {
  const cardsData = [
    { title: "Total Members", percentage: "+12%", comparisonText: "vs last week", mainValue: "36", buttonText: "View" },
    { title: "Pending Invites", percentage: "+1", comparisonText: "new this week", mainValue: "4", buttonText: "Manage" },
    { title: "Roles Configured", percentage: "stable", comparisonText: "last 30 days", mainValue: "5", buttonText: "Edit" },
    { title: "Team Leads", percentage: "+2", comparisonText: "vs last month", mainValue: "6", buttonText: "Assign" },
    { title: "Departments", percentage: "0%", comparisonText: "vs previous", mainValue: "3", buttonText: "Review" },
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]"> {/* Container-queried gap */}
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',  // 30% of container width
                flex: '0 0 auto'  // Prevent flex growing
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default ManageTeamList;